import roles from '../pages/customers/roles/roles';
import checkRole from './checkRole';
import { isProd } from './isProd';



const isSpecialUserOnProd = (user, userRoles) => {
  return isProd && user?.id && userRoles &&
    ((checkRole(userRoles, [ roles['content-manager'].key ]) && user.id === 695)
      || (checkRole(userRoles, [ roles['lead-coloring-editor'].key ]) && user.id === 709)
      || (checkRole(userRoles, [ roles['coloring-designer'].key ]) && user.id === 607));
};

export default isSpecialUserOnProd;
